import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformV2ClientResponse } from 'helpers/core';

import URLS from 'constants/urls';

const handler = ({ httpClient: http }, { userId, venueId }) =>
  http.get(URLS.home.recommendations(userId, venueId), { ignoreInternalError: true }).then(transformV2ClientResponse);

export default makeEntityScaffold('RECOMMENDATIONS', handler, {
  defaultKey: (nil, { userId, venueId }) => [userId, venueId].join(),
});
